import { DEALS_PICKER_PAGE_SIZE } from "@/lib/ops/opsDealsListQuery";
import { listOpsDeals } from "@/lib/opsPaperworkClient";

export type SalesDeskDealRow = {
  id: string;
  displayName: string | null;
  status: string;
  serial: string | null;
  createdAt: string;
  updatedAt: string;
  productName: string;
  saleName: string;
  eventHint: string;
  officeName: string;
  salespersonName: string;
};

function asRecord(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return value as Record<string, unknown>;
}

function text(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function salesDeskDealFromRow(raw: unknown): SalesDeskDealRow | null {
  const row = asRecord(raw);
  const id = text(row.id);
  if (!id) return null;
  const metadata = asRecord(row.metadata);
  const createdAt = text(row.created_at);
  return {
    id,
    displayName: text(row.display_name) || null,
    status: text(row.status),
    serial: text(row.serial) || null,
    createdAt,
    updatedAt: text(row.updated_at) || createdAt,
    productName: text(row.type_match_product_name),
    saleName: text(row.type_match_sale_name),
    eventHint: text(metadata.inventory_host_event_hint),
    officeName: text(row.office_name),
    salespersonName: text(row.salesperson_name),
  };
}

export async function listSalesDeskDeals(): Promise<
  { ok: true; deals: SalesDeskDealRow[] } | { ok: false; error: string }
> {
  const deals: SalesDeskDealRow[] = [];
  for (let page = 1; page <= 5; page += 1) {
    const result = await listOpsDeals({ status: "active", page, page_size: DEALS_PICKER_PAGE_SIZE });
    if (!result.ok) return { ok: false, error: result.error };
    const rows = Array.isArray(result.data.deals) ? result.data.deals : [];
    for (const row of rows) {
      const deal = salesDeskDealFromRow(row);
      if (deal) deals.push(deal);
    }
    if (rows.length < DEALS_PICKER_PAGE_SIZE) break;
  }
  return { ok: true, deals };
}
